import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo9 } from "../../../routes/Module9";
import Imagen1 from "../../../images/modulo9/postamedica.png";
import Imagen2 from "../../../images/modulo9/pueblo.png";

import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 6.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[5];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo9.content[0].activities[6].name}`,
    linkNext: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[6].path}`,
    titlePrev: `${modulo9.content[0].activities[4].name}`,
    linkPrev: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo9.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>Conversa con un compañero, compañera o familiar. </li>
        <li>
          Observen los siguientes casos y respondan qué ministerio debería
          ocuparse de cada problema.
        </li>
      </ul>

      <Card>
        <div className="row align-items-center p-4 p-lg-0">
          <div className="col-lg-4 col-md-6 col-12">
            <h4>Caso 1:</h4>
            <p className="fs-5">
              En el barrio de Jailer, en Moyobamba (San Martín), no hay
              hospital. Hay una posta médica donde a veces no están la doctora
              ni la enfermera. ¿Qué ministerio podría solucionar este problema y
              cómo?
            </p>
          </div>
          <div className="col-lg-8 col-md-6 col-12">
            <img src={Imagen1} alt="Electores" className="img-fluid" />
          </div>
        </div>
      </Card>

      <Card>
        <div className="row align-items-center p-4 p-lg-0">
          <div className="col-lg-4 col-md-6 col-12">
            <h4>Caso 2:</h4>
            <p className="fs-5">
              En el pueblo de Eli no hay escuela. Por eso tiene que caminar una
              hora de ida y una hora de vuelta para poder ir a la escuela del
              pueblo vecino. ¿Qué ministerio podría solucionar este problema y
              cómo?
            </p>
          </div>
          <div className="col-lg-8 col-md-6 col-12">
            <img src={Imagen2} alt="Electores" className="img-fluid" />
          </div>
        </div>
      </Card>

      <GuiaDocente>
        <p>
          Lea las indicaciones y los casos. Dialoguen sobre los casos. Para el
          Caso 1, debería ocuparse el Ministerio de Salud y, para el Caso 2, el
          Ministerio de Educación. Asegúrese de que se justifiquen las
          respuestas durante el diálogo.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
